(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-product"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(section) {
    if (!section || section.dataset.mppInit) return;
    section.dataset.mppInit = 'true';

    const main = section.querySelector('.mpp-gallery__image');
    const thumbs = Array.from(section.querySelectorAll('[data-mpp-thumb]'));
    const previousButton = section.querySelector('[data-mpp-prev]');
    const nextButton = section.querySelector('[data-mpp-next]');
    let currentIndex = Math.max(
      0,
      thumbs.findIndex((thumb) => thumb.classList.contains('is-active'))
    );

    function showImage(index) {
      if (!main || thumbs.length === 0) return;

      currentIndex = (index + thumbs.length) % thumbs.length;
      const activeThumb = thumbs[currentIndex];

      if (activeThumb.dataset.src) {
        main.src = activeThumb.dataset.src;
        main.srcset = '';
      }

      thumbs.forEach((thumb, thumbIndex) => {
        const active = thumbIndex === currentIndex;
        thumb.classList.toggle('is-active', active);
        thumb.setAttribute('aria-current', active ? 'true' : 'false');
      });
    }

    thumbs.forEach((thumb, index) => {
      thumb.addEventListener('click', () => showImage(index));
    });

    previousButton?.addEventListener('click', () => {
      showImage(currentIndex - 1);
    });

    nextButton?.addEventListener('click', () => {
      showImage(currentIndex + 1);
    });

    const galleryMain = section.querySelector('.mpp-gallery__main');
    let touchStartX = 0;

    galleryMain?.addEventListener(
      'touchstart',
      (event) => {
        touchStartX = event.changedTouches[0].clientX;
      },
      { passive: true }
    );

    galleryMain?.addEventListener(
      'touchend',
      (event) => {
        const distance = event.changedTouches[0].clientX - touchStartX;
        if (Math.abs(distance) < 45) return;
        showImage(distance > 0 ? currentIndex - 1 : currentIndex + 1);
      },
      { passive: true }
    );

    const select = section.querySelector('[data-mpp-variant]');
    const price = section.querySelector('[data-mpp-price]');
    const submit = section.querySelector('[data-mpp-submit]');
    const submitText = section.querySelector('[data-mpp-submit-text]');

    if (select) {
      select.addEventListener('change', () => {
        const option = select.options[select.selectedIndex];

        if (price && option.dataset.price) {
          price.textContent = new Intl.NumberFormat(
            document.documentElement.lang || 'en',
            {
              style: 'currency',
              currency: window.Shopify?.currency?.active || 'AED'
            }
          ).format(Number(option.dataset.price) / 100);
        }

        if (main && option.dataset.image) {
          main.src = option.dataset.image;
          main.srcset = '';

          const matchingIndex = thumbs.findIndex(
            (thumb) => thumb.dataset.src === option.dataset.image
          );

          if (matchingIndex >= 0) {
            currentIndex = matchingIndex;
            thumbs.forEach((thumb, index) => {
              thumb.classList.toggle('is-active', index === currentIndex);
            });
          }
        }

        if (submit) {
          submit.disabled = option.disabled;
          if (submitText) {
            submitText.textContent = option.disabled ? 'Sold out' : 'Add to cart';
          }
        }
      });
    }
  }

  document.querySelectorAll('[id^="MariamProductHero-"]').forEach(init);

  document.addEventListener('shopify:section:load', (event) => {
    init(event.target.querySelector('[id^="MariamProductHero-"]'));
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mariam-testimonial-slider"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-mariam-slider]').forEach(function(root){if(root.dataset.ready==='true')return;root.dataset.ready='true';var slides=[].slice.call(root.querySelectorAll('[data-slide]'));var dots=[].slice.call(root.querySelectorAll('[data-dot]'));var current=0;function show(index){if(!slides.length)return;slides[current].classList.remove('is-active');if(dots[current])dots[current].classList.remove('is-active');current=(index+slides.length)%slides.length;slides[current].classList.add('is-active');if(dots[current])dots[current].classList.add('is-active')}var prev=root.querySelector('[data-prev]');var next=root.querySelector('[data-next]');if(prev)prev.addEventListener('click',function(){show(current-1)});if(next)next.addEventListener('click',function(){show(current+1)});dots.forEach(function(dot){dot.addEventListener('click',function(){show(Number(dot.dataset.dot))})})});

  } catch(e) { console.error(e); }
})();
})();
